// To prevent react-router from restoring previous scrolling position
// so switching tabs would always scroll to the top

import { useEffect } from "react";
import { useLocation } from "react-router";

export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    const unlisten = () => window.scrollTo(0, 0);
    return () => {
      unlisten();
    };
  }, [location]);

  return null;
}
